function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

export var UrlHelper = /*#__PURE__*/function () {
  function UrlHelper() {
    _classCallCheck(this, UrlHelper);
  }

  _createClass(UrlHelper, null, [{
    key: "BuildUserUrl",
    value: function BuildUserUrl(baseUrl, userInfo) {
      var _userInfo$user, _userInfo$user2, _userInfo$user3, _userInfo$user4, _userInfo$user5, _userInfo$user6, _userInfo$user7, _userInfo$user8;

      var replacements = [{
        pattern: /\{\{isAuthenticated\}\}/ig,
        replacement: !!userInfo
      }, {
        pattern: /\{\{userImageUrl\}\}/ig,
        replacement: userInfo === null || userInfo === void 0 ? void 0 : userInfo.ImageUrl
      }, {
        pattern: /\{\{userProfileUrl\}\}/ig,
        replacement: userInfo === null || userInfo === void 0 ? void 0 : userInfo.ProfileUrl
      }, {
        pattern: /\{\{userIsHeadOfHousehold\}\}/ig,
        replacement: userInfo === null || userInfo === void 0 ? void 0 : userInfo.IsHeadOfHousehold
      }, {
        pattern: /\{\{userIsStaff\}\}/ig,
        replacement: userInfo === null || userInfo === void 0 ? void 0 : userInfo.IsStaff
      }, {
        pattern: /\{\{userDonorId\}\}/ig,
        replacement: userInfo === null || userInfo === void 0 ? void 0 : userInfo.DonorId
      }, {
        pattern: /\{\{userDisplayName\}\}/ig,
        replacement: userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$user = userInfo.user) === null || _userInfo$user === void 0 ? void 0 : _userInfo$user.displayName
      }, {
        pattern: /\{\{userFirstName\}\}/ig,
        replacement: userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$user2 = userInfo.user) === null || _userInfo$user2 === void 0 ? void 0 : _userInfo$user2.firstName
      }, {
        pattern: /\{\{userLastName\}\}/ig,
        replacement: userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$user3 = userInfo.user) === null || _userInfo$user3 === void 0 ? void 0 : _userInfo$user3.lastName
      }, {
        pattern: /\{\{userMiddleName\}\}/ig,
        replacement: userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$user4 = userInfo.user) === null || _userInfo$user4 === void 0 ? void 0 : _userInfo$user4.middleName
      }, {
        pattern: /\{\{userNickName\}\}/ig,
        replacement: userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$user5 = userInfo.user) === null || _userInfo$user5 === void 0 ? void 0 : _userInfo$user5.nickname
      }, {
        pattern: /\{\{userEmail\}\}/ig,
        replacement: userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$user6 = userInfo.user) === null || _userInfo$user6 === void 0 ? void 0 : _userInfo$user6.email
      }, {
        pattern: /\{\{userLocale\}\}/ig,
        replacement: userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$user7 = userInfo.user) === null || _userInfo$user7 === void 0 ? void 0 : _userInfo$user7.locale
      }, {
        pattern: /\{\{userTimeZone\}\}/ig,
        replacement: userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$user8 = userInfo.user) === null || _userInfo$user8 === void 0 ? void 0 : _userInfo$user8.timeZoneId
      }];
      /*Notice: do NOT provide a method to replace arbitrary settings from dp_Configuration_Settings
      * For instance, if you were to define a scheme where the url parameter `{{config.SOMEVALUE}}` would search for SOMEVALUE in the configuration settings
      * so you wouldn't have to code for every possibility, then nothing would stop someone from adding the parameter `{{config.Background_Check_Password}}`
      * and then they would have access to sensitive information
      */

      replacements.forEach(function (repl) {
        if (repl.pattern.test(baseUrl)) {
          var _repl$replacement;

          var paramValue = encodeURIComponent((_repl$replacement = repl.replacement) !== null && _repl$replacement !== void 0 ? _repl$replacement : "");
          baseUrl = baseUrl.replace(repl.pattern, paramValue);
        }
      });
      return baseUrl;
    }
  }, {
    key: "AddQueryParameter",
    value: function AddQueryParameter(baseUrl, paramName, paramValue) {
      var sep = baseUrl.includes("?") ? "&" : "?";
      return "".concat(baseUrl).concat(sep).concat(encodeURIComponent(paramName), "=").concat(encodeURIComponent(paramValue));
    }
  }]);

  return UrlHelper;
}();